export class ExpiredSessionError extends Error {
    unauthorized = true;
    constructor(message) {
        super(message || 'Sessión caducada');
        this.name = 'ExpiredSessionError';
    }
}
//# sourceMappingURL=expired_session_error.js.map